<script setup>
import { ref } from 'vue'
import { useWebSiteStore } from '@/stores/website.store'
import { useNotify } from '@/composables/notify'
import { useRouter } from 'vue-router'
import i18n from '@/plugins/i18n'

const router = useRouter()

const email = ref('')
const loading = ref(false)

const websiteStore = useWebSiteStore()
const t = i18n.global.t
const {notifyError, notifyInfo} = useNotify()

const required = (val) => !!val || t('form.field.required')
const emailRule = (val) =>
  !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || t('form.field.invalidEmail')

const onForgotPasswordAsync = async() => {
  try {
    loading.value = true
    if (!email.value) {
      notifyError(t('auth.errors.emailRequired'))
      return
    }
    await websiteStore.sendPasswordResetAsync(email.value)

    notifyInfo(t('auth.messages.passwordResetSent'))
  } catch (error) {
    notifyError(t('auth.errors.passwordResetFailed'))
  } finally {
    loading.value = false
  }

  router.push({ name: 'request-reset-password' })
}

</script>

<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient">
        <div class="column items-center">
          <!-- Header -->
          <div class="column items-center q-gutter-md">
            <div class="text-h5 q-mb-md">
              {{ $t('auth.requestPasswordReset') }}
            </div>

            <q-avatar
              size="6rem"
              class="bg-white"
            >
              <img
                src="@/assets/extended-logo.svg"
                alt="Logo"
                style="max-width:80%;max-height:80%;object-fit:contain;"
              >
            </q-avatar>
          </div>

          <!-- Card -->
          <div class="q-mt-xl column login-card">
            <div class="column">
              <q-input
                v-model="email"
                class="q-mt-md"
                :placeholder="$t('auth.email')"
                :rules="[required, emailRule]"
              >
                <template #prepend>
                  <q-icon name="mdi-email" />
                </template>
              </q-input>
            </div>

            <div class="q-mt-lg">
              <q-btn
                color="primary"
                class="full-width q-pa-sm"
                :label="$t('auth.sendResetLink')"
                :loading="loading"
                @click="onForgotPasswordAsync"
              />
            </div>

            <!-- Actions -->
            <div class="login-actions column items-center q-mt-md">
              <router-link
                to="/login"
                class="link"
              >
                {{ $t('auth.backToLogin') }}
              </router-link>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/auth-forms.scss';
</style>
